import { h } from 'preact'
import { Geografi, GeografiMedStemmeinfo } from '../../../domain'
import { useAppState } from '../../../../lib/redux-provider-nohooks'
import { Message } from '../../../../lib/intl/Message'
import { NavLinks } from '../../shared/NavLinks/NavLinks'

import s from './StorsteKommuner.module.css'

type Props = {
  geografi: GeografiMedStemmeinfo[]
}

export function StorsteKommuner(props: Props) {
  const { geografi } = props
  const storsteKommuner = geografi
    .filter(geografi => geografi.type === 'Kommune')
    .sort((a, b) => {
      const innbyggertallA = a.innbyggertall || 0
      const innbyggertallB = b.innbyggertall || 0
      return innbyggertallB - innbyggertallA
    })
    .slice(0, 20)

  return (
    <section class={s.storsteKommuner}>
      <h3>
        <Message id="storste-kommuner-tittel" />
      </h3>
      <NavLinks grunndata={storsteKommuner} sorter={false} type="kommune" />
    </section>
  )
}

export function ConnectedStorsteKommuner() {
  const state = useAppState()

  return <StorsteKommuner geografi={state.grunndata.geografi} />
}
